<template>
  <div class="mb-4 mt-8 flex flex-row items-center rounded-lg bg-muted p-3">
    <span class="mr-2">
      <slot name="icon"></slot>
    </span>
    <h2 class="text-sm font-medium">
      <slot />
    </h2>
  </div>
</template>
